import { defineMessages } from 'react-intl';

export default defineMessages({
    goBackToDashboard: {
        id: '_.outstanding_view.dashboardActionPanel.goBackToDashboard',
        defaultMessage: "I'll decide later"
    },
    topUpApprovalSummary: {
        id: '_.outstanding_view.dashboardActionPanel.topUpApprovalSummary',
        defaultMessage:
            'You can draw down up to {amount} with an interest rate of {interestRate} per month.'
    },
    withdrawMessage: {
        id: '_.outstanding_view.dashboardActionPanel.withdrawMessage',
        defaultMessage: 'I want to withdraw {input}'
    },
    interestOnlyWithdrawMessage: {
        id: '_.outstanding_view.dashboardActionPanel.interestOnlyWithdrawMessage',
        defaultMessage:
            'I want to extend my interest-only period and withdraw {input}'
    },
    drawdownCTA: {
        id: '_.outstanding_view.dashboardActionPanel.drawdownAmount',
        defaultMessage: 'Continue with {drawdownAmount}'
    },
    extendInterestOnly: {
        id: '_.outstanding_view.dashboardActionPanel.extendInterestOnly',
        defaultMessage: 'You can now extend your grace period by 3 months.'
    },
    extendInterestOnlyWithDrawdown: {
        id: '_.outstanding_view.dashboardActionPanel.extendInterestOnlyNoChoice',
        defaultMessage: 'Would you also like a credit increase?'
    },
    extendInterestOnlyCTA: {
        id: '_.outstanding_view.dashboardActionPanel.extendInterestOnlyCTA',
        defaultMessage: 'Extend my Interest-Only Period'
    },
    tabInterestOnly: {
        id: '_.outstanding_view.dashboardActionPanel.tabInterestOnly',
        defaultMessage: 'Only extend interest-only period'
    },
    tabInterestOnlyWithDrawdown: {
        id: '_.outstanding_view.dashboardActionPanel.tabInterestOnlyWithDrawdown',
        defaultMessage: 'Extend and drawdown more funds'
    },
    interestOnlyExtensionApprovalSummary: {
        id: '_.outstanding_view.dashboardActionPanel.interestOnlyExtensionSummary',
        defaultMessage:
            'You can extend your interest-only period by 3 months keeping your interest rate at {interestRate} per month'
    },
    interestOnlyExtensionApprovalWithFundsSummary: {
        id: '_.outstanding_view.dashboardActionPanel.interestOnlyExtensionWithFundsSummary',
        defaultMessage:
            'You can extend your interest-only period by 3 months and draw down up to {amount} with an interest rate of {interestRate} per month'
    },
    chooseInterestOnlyDrawdownType: {
        id: '_.outstanding_view.dashboardActionPanel.chooseInterestOnlyDrawdownType',
        defaultMessage:
            'Please select below whether you would like to extend your interest-only period, or extend and drawdown more funds'
    }
});
